import axios from "axios";
import { configUrl } from "config";



const notificationService = {
    getAll: async (pageNumber, pageSize, isPublished) => {
        const res = await axios.get(
            `${configUrl.AssessmentServer}/api/Notification/getAllGlobalNotifications/${pageNumber}/${pageSize}/${isPublished}`
        );
        return res.data; // expected: { data: { $values: [...] }, totalCount }
    },
};

export default notificationService;
